import { z } from 'zod';

export const PaymentProviderEnum = z.enum(['stripe', 'iyzico']);
export const CurrencyEnum = z.enum(['USD', 'EUR', 'TRY']);

export const CreatePaymentConfigSchema = z.object({
    provider: PaymentProviderEnum,
    apiKey: z.string(),
    secretKey: z.string(),
    endpoint: z.string().optional(),
});

export const ChargeSchema = z.object({
    amount: z.number().positive(),
    currency: CurrencyEnum,
    source: z.string(), // Card token or Customer ID
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
});

export const SubscriptionSchema = z.object({
    customerId: z.string(),
    planId: z.string(), // Price ID (Stripe)
    quantity: z.number().min(1).default(1),
});

export const WalletSchema = z.object({
    userId: z.string(),
    balance: z.number().default(0),
    currency: CurrencyEnum.default('TRY'),
});
